import qs from 'qs';

import { serviceApi } from '../service';

const getImageUrl = ({ latitude, longitude, query, width, height }) =>
  `location?${qs.stringify({
    latitude,
    longitude,
    query,
    width,
    height,
  })}`;

const convertBlobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = () => {
      reader.abort();
      reject(new Error('An error occurred reading this file.'));
    };

    reader.readAsDataURL(blob);
  });

export const getMapImage = (params) =>
  serviceApi
    .fetch(getImageUrl(params))
    .then((response) => {
      if (response.status === 200) {
        return response;
      }
      return Promise.reject(response);
    })
    .then((response) => response.blob())
    .then(convertBlobToBase64)
    .catch(() => null);

const getPostcode = (coordinates) => {
  const [latitude, longitude] = coordinates.split(',');
  return serviceApi.fetchJSON(`postcode?${qs.stringify({ latitude, longitude })}`);
};

export const locationApi = { getMapImage, getPostcode };
